import { defineComponent as i, computed as o, openBlock as a, createElementBlock as n, normalizeClass as r, renderSlot as l } from "vue";
import { convertColors as d, convertSpacings as e } from "../../../utils/tailwindUnitsConverter.js";
import { _ as c } from "../../../_plugin-vue_export-helper-dad06003.js";
const g = i({
  name: "VText",
  props: {
    center: {
      type: Boolean,
      default: !1
    },
    weight: {
      type: String,
      validator(t) {
        return ["regular", "bold"].indexOf(t) !== -1;
      },
      default: "regular"
    },
    tag: {
      type: String,
      validator(t) {
        return ["p", "div", "span"].indexOf(t) !== -1;
      },
      default: "p"
    },
    size: {
      type: String,
      validator(t) {
        return ["xxs", "xs", "s", "m"].indexOf(t) !== -1;
      },
      default: "m"
    },
    bottomSpacing: {
      type: String,
      default: "",
      validator: (t) => ["xs", "s", "m", "l", ""].includes(t)
    },
    topSpacing: {
      type: String,
      default: "",
      validator: (t) => ["xs", "s", "m", "l", "xl", ""].includes(t)
    },
    leftSpacing: {
      type: String,
      default: "",
      validator: (t) => ["xs", "s", "m", "l", "xl", ""].includes(t)
    },
    rightSpacing: {
      type: String,
      default: "",
      validator: (t) => ["xs", "s", "m", "l", "xl", ""].includes(t)
    },
    /** One of the colors defined in src/assets/styles/variables/colors.css */
    color: {
      type: String,
      default: "grey-900",
      validator: (t) => [
        "grey-400",
        "grey-500",
        "grey-600",
        "grey-800",
        "grey-900",
        "white",
        "green",
        "orange",
        "red",
        ""
      ].includes(t)
    },
    renderSingleLine: {
      type: Boolean,
      default: !1
    }
  },
  setup(t) {
    return {
      cssClass: o(() => [
        t.size === "xxs" ? "tw-text-xxs" : "",
        t.size === "xs" ? "tw-text-xs" : "",
        t.size === "s" ? "tw-text-sm" : "",
        t.size === "m" ? "tw-text-base" : "",
        t.weight === "regular" ? "tw-font-normal" : "",
        t.weight === "bold" ? "tw-font-bold" : "",
        t.center ? "tw-text-center" : "",
        t.color !== "" ? "tw-text-" + d(t.color) : "",
        t.renderSingleLine ? "tw-break-normal tw-whitespace-nowrap tw-overflow-hidden tw-overflow-ellipsis" : "",
        t.bottomSpacing !== "" ? "tw-mb-" + e(t.bottomSpacing) : "",
        t.topSpacing !== "" ? "tw-mt-" + e(t.topSpacing) : "",
        t.leftSpacing !== "" ? "tw-ml-" + e(t.leftSpacing) : "",
        t.rightSpacing !== "" ? "tw-mr-" + e(t.rightSpacing) : ""
      ])
    };
  }
});
function w(t, s, f, u, m, S) {
  return t.tag === "div" ? (a(), n("div", {
    key: 0,
    class: r(["tw-not-italic tw-font-sans tw-break-words tw-m-0", t.cssClass])
  }, [
    l(t.$slots, "default")
  ], 2)) : t.tag === "span" ? (a(), n("span", {
    key: 1,
    class: r(["tw-not-italic tw-font-sans tw-break-words tw-m-0", t.cssClass])
  }, [
    l(t.$slots, "default")
  ], 2)) : (a(), n("p", {
    key: 2,
    class: r(["tw-not-italic tw-font-sans tw-break-words tw-m-0", t.cssClass])
  }, [
    l(t.$slots, "default")
  ], 2));
}
const v = /* @__PURE__ */ c(g, [["render", w]]);
export {
  v as default
};
